import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import { IconProps } from './Icon'
import TrackingIcon from './TrackingIcon'

/**
 * パートナーの車アイコン
 */
const PartnerIcon: React.FC<IconProps> = (props) => {
  return (
    <TrackingIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="55"
        height="55"
        viewBox="0 0 55 55"
      >
        <defs>
          <filter
            id="PartnerIconFilter"
            x="0"
            y="0"
            width="55"
            height="55"
            filterUnits="userSpaceOnUse"
          >
            <feGaussianBlur stdDeviation="3" result="b" />
            <feFlood floodOpacity="0.239" />
            <feComposite operator="in" in2="b" />
            <feComposite in="SourceGraphic" />
          </filter>
        </defs>
        <g transform="translate(11 11)">
          <g
            transform="matrix(1, 0, 0, 1, -11, -11)"
            filter="url(#PartnerIconFilter)"
          >
            <g
              transform="translate(11 11)"
              fill={CLIENT_SETTINGS.colors.iconPartner}
            >
              <path
                d="M 26.35848999023438 34 L 6.641510009765625 34 C 2.427969932556152 34 -1 30.57202911376953 -1 26.35848999023438 L -1 6.641510009765625 C -1 2.427969932556152 2.427969932556152 -1 6.641510009765625 -1 L 26.35848999023438 -1 C 30.57202911376953 -1 34 2.427969932556152 34 6.641510009765625 L 34 26.35848999023438 C 34 30.57202911376953 30.57202911376953 34 26.35848999023438 34 Z"
                stroke="none"
              />
              <path
                d="M 6.641510009765625 0 C 2.973499298095703 0 0 2.973499298095703 0 6.641510009765625 L 0 26.35848999023438 C 0 30.0264892578125 2.973499298095703 33 6.641510009765625 33 L 26.35848999023438 33 C 30.0264892578125 33 33 30.0264892578125 33 26.35848999023438 L 33 6.641510009765625 C 33 2.973499298095703 30.0264892578125 0 26.35848999023438 0 L 6.641510009765625 0 M 6.641510009765625 -2 L 26.35848999023438 -2 C 31.1234302520752 -2 35 1.876569747924805 35 6.641510009765625 L 35 26.35848999023438 C 35 31.1234302520752 31.1234302520752 35 26.35848999023438 35 L 6.641510009765625 35 C 1.876569747924805 35 -2 31.1234302520752 -2 26.35848999023438 L -2 6.641510009765625 C -2 1.876569747924805 1.876569747924805 -2 6.641510009765625 -2 Z"
                stroke="none"
                fill={CLIENT_SETTINGS.colors.textForMainBackground}
              />
            </g>
          </g>
          <g transform="translate(7.382 6.513)">
            <path
              d="M20,8H17V4H3A2.006,2.006,0,0,0,1,6V17H3a3,3,0,0,0,6,0h6a3,3,0,0,0,6,0h2V12ZM6,18.5A1.5,1.5,0,1,1,7.5,17,1.5,1.5,0,0,1,6,18.5Zm13.5-9L21.46,12H17V9.5Zm-1.5,9A1.5,1.5,0,1,1,19.5,17,1.5,1.5,0,0,1,18,18.5Z"
              transform="translate(-2.604 -0.513)"
              fill={CLIENT_SETTINGS.colors.textForMainBackground}
            />
          </g>
          <path
            d="M4,0,8,7H0Z"
            transform="translate(20.255 39.817) rotate(180)"
            fill={CLIENT_SETTINGS.colors.iconPartner}
          />
        </g>
      </svg>
    </TrackingIcon>
  )
}

export default PartnerIcon
